var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPostgreSql(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1936",
    "data-name": "Rectangle 1936",
    width: 52,
    height: 52,
    transform: "translate(1244 2136)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_40",
    "data-name": "Mask Group 40",
    transform: "translate(-1244 -2136)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_3",
    transform: "translate(1244.715 2136)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19817",
    "data-name": "Path 19817",
    d: "M37.73,37.849c.331-2.755.232-3.159,2.284-2.713l.521.046a11.871,11.871,0,0,0,4.855-.817c2.61-1.211,4.158-3.234,1.584-2.7-5.871,1.211-6.275-.777-6.275-.777,6.2-9.2,8.792-20.877,6.555-23.735-6.1-7.8-16.664-4.11-16.841-4.014l-.056.01a20.93,20.93,0,0,0-3.917-.408,9.676,9.676,0,0,0-6.2,1.857S1.394-3.167,2.271,14.358c.186,3.728,5.344,28.21,11.5,20.815,2.248-2.7,4.421-4.99,4.421-4.99a5.7,5.7,0,0,0,3.725.951l.1-.089a4.084,4.084,0,0,0,.042,1.053c-1.584,1.771-1.119,2.081-4.287,2.733-3.205.661-1.322,1.837-.093,2.144a6.513,6.513,0,0,0,7.269-2.361l-.093.372c.622.5.58,3.574.668,5.773a20.777,20.777,0,0,0,.684,5.46c.448,1.209.977,4.325,5.141,3.433,3.48-.746,6.14-1.819,6.383-11.8",
    stroke: "#000",
    strokeWidth: 4.365
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19818",
    "data-name": "Path 19818",
    d: "M46.974,31.662c-5.872,1.211-6.276-.777-6.276-.777,6.2-9.2,8.792-20.877,6.555-23.736-6.1-7.8-16.664-4.109-16.841-4.013l-.057.01a20.941,20.941,0,0,0-3.918-.408,9.676,9.676,0,0,0-6.2,1.856S1.394-3.167,2.27,14.358c.186,3.728,5.344,28.21,11.5,20.815,2.248-2.7,4.421-4.99,4.421-4.99a5.7,5.7,0,0,0,3.725.951l.105-.089a4.105,4.105,0,0,0,.042,1.053c-1.585,1.771-1.119,2.081-4.287,2.733-3.205.661-1.322,1.837-.093,2.144a6.512,6.512,0,0,0,7.269-2.361l-.093.372c.621.5,1.057,3.235.984,5.716s-.122,4.185.367,5.516.977,4.325,5.141,3.433c3.48-.746,5.283-2.678,5.534-5.9.178-2.292.581-1.953.606-4l.323-.97c.373-3.106.059-4.109,2.2-3.643l.521.046a11.872,11.872,0,0,0,4.855-.817c2.61-1.211,4.158-3.234,1.584-2.7Z",
    fill: "#336791"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19819",
    "data-name": "Path 19819",
    d: "M25.2,33.443c-.162,5.78.041,11.6.606,13.016s1.777,4.166,5.942,3.274c3.479-.746,4.745-2.19,5.295-5.376.4-2.344,1.185-8.855,1.285-10.189",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.455
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19820",
    "data-name": "Path 19820",
    d: "M20.208,4.466S1.352-3.241,2.229,14.284C2.415,18.013,7.573,42.5,13.724,35.1,15.972,32.4,18,30.275,18,30.275",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.455
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19821",
    "data-name": "Path 19821",
    d: "M30.392,3.059c-.653.2,10.489-4.073,16.82,4.018,2.237,2.858-.355,14.536-6.555,23.736",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.455
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19822",
    "data-name": "Path 19822",
    d: "M40.657,30.813s.4,1.989,6.276.777c2.573-.531,1.024,1.491-1.585,2.7-2.142.994-6.943,1.249-7.021-.125-.2-3.544,2.527-2.467,2.33-3.355-.178-.8-1.4-1.584-2.206-3.542-.7-1.708-9.665-14.808,2.485-12.862.445-.092-3.169-11.557-14.54-11.744s-11,13.981-11,13.981",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "bevel",
    strokeWidth: 1.455
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19823",
    "data-name": "Path 19823",
    d: "M22.017,32.025c-1.585,1.77-1.119,2.081-4.287,2.734-3.205.661-1.322,1.837-.093,2.144a6.511,6.511,0,0,0,7.269-2.361,2.175,2.175,0,0,0-.979-2.982A1.439,1.439,0,0,0,22.017,32.025Z",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.455
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19824",
    "data-name": "Path 19824",
    d: "M21.913,31.994a8.376,8.376,0,0,1,.88-3.729c.808-2.174,2.672-4.349,1.181-11.246-1.112-5.14-8.568-1.07-8.573-.373a34.983,34.983,0,0,1-.125,6.835c-.6,4.309,2.742,7.953,6.593,7.581",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.455
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19825",
    "data-name": "Path 19825",
    d: "M20.139,16.542c-.034.238.436.873,1.048.958a1.128,1.128,0,0,0,1.167-.649c.033-.238-.436-.5-1.048-.585s-1.135.039-1.167.276Z",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.485
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19826",
    "data-name": "Path 19826",
    d: "M38.75,16.056c.033.238-.436.873-1.048.958a1.13,1.13,0,0,1-1.168-.649c-.032-.238.437-.5,1.048-.585s1.134.039,1.168.276Z",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.243
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19827",
    "data-name": "Path 19827",
    d: "M40.937,14.409c.1,1.867-.4,3.139-.466,5.126-.094,2.889,1.377,6.2-.839,9.506",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.455
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19828",
    "data-name": "Path 19828",
    d: "M0,7.031",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.35
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPostgreSql);
export default __webpack_public_path__ + "static/media/PostgreSQL.609da23e6c9db9c8098c61ac4f6b3592.svg";
export { ForwardRef as ReactComponent };